import fetch from '@/utils/fetch'

// 加载购物车
export function loadList (merchId) {
  return fetch({
    url: '/website/cart/current/' + merchId,
    method: 'post'
  })
}

// 移除商品
export function removeGoods (data) {
  return fetch({
    url: '/website/cart/remove',
    method: 'post',
    data
  })
}

// 清空购物车
export function removeCart (data) {
  return fetch({
    url: '/website/cart/clear',
    method: 'post'
  })
}

// 加入购物车
export function addToCart (data) {
  return fetch({
    url: '/website/cart/add',
    method: 'post',
    data
  })
}

// 更新购物车
export function updateCart (data) {
  return fetch({
    url: '/website/cart/update',
    method: 'post',
    data
  })
}

// 计算
export function calAmount (data) {
  return fetch({
    url: '/website/cart/order/calculate',
    method: 'post',
    data
  })
}

// 单个商品计算
export function singleCalAmount (data) {
  return fetch({
    url: '/website/retail/order/calculate',
    method: 'post',
    data
  })
}
